import { useCallback, useState, useMemo, useContext } from 'react'
import { common } from '@ocean/ui'
import { AnchorElementsContext } from 'core/contexts'

const { DecoratorContext } = common

const AnchorElementsLayer: React.FC = ({ children }) => {
  const { scrollTop } = useContext(DecoratorContext)
  const [anchorElements, setAnchorElements] = useState<Record<string, React.RefObject<any>>>({})

  const handleAddAnchorElement = useCallback(
    (elementName: string, elementRef: React.RefObject<any>) => {
      setAnchorElements(state => ({ ...state, [elementName]: elementRef }))
    },
    []
  )

  const scrollToAnchor = useCallback(
    (anchorName: string) => {
      if (scrollTop && anchorElements && anchorElements[anchorName]) {
        const { top } = anchorElements[anchorName].current.getBoundingClientRect()
        scrollTop(top)
      }
    },
    [anchorElements, scrollTop]
  )

  const anchorElementsContextValue = useMemo(
    () => ({ addAnchorElement: handleAddAnchorElement, anchorElements, scrollToAnchor }),
    [handleAddAnchorElement, anchorElements, scrollToAnchor]
  )

  return (
    <AnchorElementsContext.Provider value={anchorElementsContextValue}>
      <>{children}</>
    </AnchorElementsContext.Provider>
  )
}

export default AnchorElementsLayer
